export default __webpack_public_path__ + "static/media/traffic-lights-green.a94133db.png";